import SvgIcon from '@mui/material/SvgIcon';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import AccountCircleIcon from '@mui/icons-material/AccountCircleOutlined';
import AnalyticsIcon from '@mui/icons-material/BarChartRounded';
import GroupsIcon from '@mui/icons-material/GroupsOutlined';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import MoneyIcon from '@mui/icons-material/CurrencyPoundOutlined';
import TokenOutlinedIcon from '@mui/icons-material/TokenOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { routes } from '../../../particles/common';
import AssistantIcon from '@mui/icons-material/Code';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ApiIcon from '@mui/icons-material/Api';
import RepeatIcon from '@mui/icons-material/Repeat';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActiveOutlined';
import BugReportIcon from '@mui/icons-material/BugReport';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
export type MenuItem = {
  label: string;
  Icon: typeof SvgIcon;
  cssClass?: string;
  to?: string;
  subItems?: MenuItem[];
};

export type MenuGroup = {
  label?: string;
  items: MenuItem[];
};

const menuConfigAdmin: MenuGroup[] = [
  {
    items: [
      {
        label: `Dashboard`,
        Icon: DashboardIcon,
        cssClass: `primary`,
        to: routes.adminDashboard
      },
      {
        label: `Team`,
        Icon: GroupsIcon,
        cssClass: `primary`,
        to: routes.adminTeam
      },
      {
        label: `Account`,
        Icon: AccountCircleIcon,
        cssClass: `primary`,
        to: routes.adminAccount
      },
      {
        label: `Billing`,
        Icon: MoneyIcon,
        cssClass: `primary`,
        to: routes.adminBilling
      }
    ]
  }
];

const menuConfigSuperAdmin: MenuGroup[] = [
  {
    items: [
      {
        label: `Negotiator`,
        Icon: DashboardIcon,
        cssClass: `primary`,
        to: routes.SA_Negotiator
      }
    ]
  },
  {
    label: `Core`,
    items: [
      {
        label: `Core`,
        Icon: FeaturedPlayListIcon,
        cssClass: `primary`,
        to: routes.SA_Core
      },
      {
        label: `Unified Users`,
        Icon: PeopleAltOutlinedIcon,
        cssClass: `primary`,
        to: routes.SA_Unified_Users
      },
      {
        label: `Custom Values`,
        Icon: AssistantIcon,
        cssClass: `primary`,
        to: routes.SA_CustomValues
      }
    ]
  },
  {
    label: `Billing & Analytics`,
    items: [
      {
        label: `Billing Accounts`,
        Icon: LocationCityIcon,
        cssClass: `primary`,
        to: routes.SA_BillingAccounts
      },
      {
        label: `Bills`,
        Icon: TokenOutlinedIcon,
        cssClass: `primary`,
        to: routes.SA_Bills
      },
      {
        label: `Analytics`,
        Icon: AnalyticsIcon,
        cssClass: `primary`,
        to: routes.SA_Analytics
      }
    ]
  },
  {
    label: `Operations`,
    items: [
      {
        label: `Artifacts`,
        Icon: AutoAwesomeIcon,
        cssClass: `primary`,
        to: routes.SA_Artifacts
      },
      {
        label: `Tasks`,
        Icon: NotificationsActiveIcon,
        cssClass: `primary`,
        to: routes.SA_Jobs
      },
      {
        label: `ZAZU Audit Trails`,
        Icon: RepeatIcon,
        cssClass: `primary`,
        to: routes.SA_ZazuAuditTrails
      }
    ]
  },
  {
    label: `Docs`,
    items: [
      {
        label: `API Docs`,
        Icon: ApiIcon,
        cssClass: `primary`,
        to: routes.SA_ApiDocs
      }
    ]
  },
  {
    label: `Extension Health`,
    items: [
      {
        label: `Error Reports`,
        Icon: BugReportIcon,
        cssClass: `primary`,
        to: routes.SA_Diagnostics
      },
      {
        label: `Support Tickets`,
        Icon: SupportAgentIcon,
        cssClass: `primary`,
        to: routes.SA_SupportTickets
      },
      {
        label: `Look Up a Code`,
        Icon: ManageSearchIcon,
        cssClass: `primary`,
        to: routes.SA_DiagnosticsLookup
      }
    ]
  }
];

export default { menuConfigAdmin, menuConfigSuperAdmin };
